import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  AverageActionsType,
  calculateSecurityCheckFamilyActionsCostsType,
  ExistingControlsbylabelType,
  GetBySWIFTSourceResponse,
  GetSecurityCheckFamilyBySourceResponse,
  globalMaturityRateISOType,
  globalMaturityRateNISTType,
  globalMaturityRateType,
  IntersectionByPerimetreForSecurityControlType,
  LateRateForSecurityControlType,
  MaturityRateType,
  RisksAndIncidentsByExistingControlType,
  RisksAndIncidentsBySecurityControlType,
  SecurityCheckFamily,
  SecurityCheckFamilyResponseSCFS,
  SecurityCheckResponse,
  SecurityControlMatrixType,
  SecurityTree,
} from '../../types/securityCheckFamilysTypes'
import {
  addsecurityControlToActionApi,
  calculateAverageActionsForSecurityControlApi,
  CalculateLateRateForSecurityControlslApi,
  calculateSecurityCheckFamilyActionsCostsApi,
  getAllSecurityCheckFamilys,
  getExistingControlsByLabelApi,
  getGlobalMaturityRateApi,
  getGlobalMaturityRateApiISO,
  getGlobalMaturityRateApiNSIT,
  getIntersectionByPerimetreForSecurityControlApi,
  getMaturityRateForExistingControlsApi,
  getRisksAndIncidentsByExistingControlApi,
  getRisksAndIncidentsBySecurityControlApi,
  getSecurityCheckFamilyByNIS2Source,
  getSecurityCheckFamilyBySAMASource,
  getSecurityCheckFamilyBySWIFTSource,
  getSecurityControlsApi,
  getSecurityControlsbylistsecuritycheckApi,
  getSecurityISOApi,
  getSecurityNISTApi,
  getSecuritySOCApi,
  getSecurityTreeByFamilyIdApi,
  getSubDomainActionIdApi,
  getwithSCFScores,
  getwithSCFScoresByid,
  removeSubDomainFromActionApi,
  securityControlMatrixApi,
} from '../../api/securitycheckfamilysApi'
import { SecurityControls } from '../../types/securityControls'
import {
  SubDomain,
  SubDomainResponse,
  SubDomainType,
} from '../../types/subDomainTypes'
import i18n from '../../i18n'
import { handleError } from '../../utils/errorHandler'

export const getAllSecurity = createAsyncThunk<
  {
    securityCheckFamilies: SecurityCheckFamily[]
    total: number
    totalPages: number
    status?: number
    erreur?: boolean
    message?: string
  },
  { page?: number; pageSize?: number },
  { rejectValue: string }
>('security/getAllSecurity', async ({ page, pageSize }, thunkAPI) => {
  try {
    const response = await getAllSecurityCheckFamilys({ page, pageSize })
    console.log(response)
    return {
      securityCheckFamilies: response.securityCheckFamily || [],
      total: response.total,
      totalPages: response.totalPages,
      status: response.status,
      message: response.message,
      erreur: response.erreur,
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const fetchSecurityCheckFamilyBySWIFTSource = createAsyncThunk<
  GetBySWIFTSourceResponse,
  { page?: number; pageSize?: number; language?: string },
  { rejectValue: string }
>(
  'securityCheckFamily/fetchBySWIFTSource',
  async ({ page, pageSize, language }, thunkAPI) => {
    try {
      const response = await getSecurityCheckFamilyBySWIFTSource(
        page,
        pageSize,
        language
      )
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(
        'Failed to fetch security check families by SWIFT source.'
      )
    }
  }
)
export const getSecurityISO = createAsyncThunk<
  {
    securityCheckFamilies: SecurityCheckFamily[]
    total: number
    totalPages: number
  },
  { page?: number; pageSize?: number; language?: string; source?: string },
  { rejectValue: string }
>(
  'security/getAllSecurityISO',
  async ({ page, pageSize, language, source }, thunkAPI) => {
    try {
      const response = await getSecurityISOApi({ page, pageSize, language, source })
      return {
        securityCheckFamilies: response.securityCheckFamilies || [],
        total: response.total,
        totalPages: response.totalPages,
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const fetchSecurityCheckFamilyBySOCSource = createAsyncThunk<
  {
    securityCheckFamilies: SecurityCheckFamily[]
    total: number
    totalPages: number
  },
  { page?: number; pageSize?: number; language?: string },
  { rejectValue: string }
>(
  'securityCheckFamily/fetchBySOCSource',
  async ({ page, pageSize, language }, thunkAPI) => {
    try {
      const response = await getSecuritySOCApi({ page, pageSize, language })
      return {
        securityCheckFamilies: response.securityCheckFamilies || [],
        total: response.total,
        totalPages: response.totalPages,
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const getSecurityNIST = createAsyncThunk<
  {
    securityCheckFamilies: SecurityCheckFamily[]
    total: number
    totalPages: number
  },
  { page?: number; pageSize?: number; language?: string },
  { rejectValue: string }
>(
  'security/getAllSecurityNIST',
  async ({ page, pageSize, language }, thunkAPI) => {
    try {
      const response = await getSecurityNISTApi({ page, pageSize, language })
      return {
        securityCheckFamilies: response.securityCheckFamilies || [],
        total: response.total,
        totalPages: response.totalPages,
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const getSubDomainByActionId = createAsyncThunk<
  SubDomainResponse,
  string,
  { rejectValue: string }
>('security/getSecurityControlsByActionId', async (ActionId, thunkAPI) => {
  try {
    const response = await getSubDomainActionIdApi(ActionId)
    console.log('response', response)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addSecurityControlToAction = createAsyncThunk<
  SecurityControls,
  {
    _id: string
    securityCheckFamilies: string[]
    securityControls: string[]
    subDomains: string[]
  },
  { rejectValue: string }
>(
  'security/addSecurityControlToAction',
  async (
    { securityCheckFamilies, securityControls, subDomains, _id },
    thunkAPI
  ) => {
    try {
      const response = await addsecurityControlToActionApi({
        securityCheckFamilies,
        securityControls,
        subDomains,
        _id,
      })
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const removeSubDomainFromAction = createAsyncThunk<
  SubDomain[],
  { SubDomain: SubDomainType; _id: string },
  { rejectValue: string }
>(
  'subdomains/removeSubDomainToAction',
  async ({ SubDomain, _id }, thunkAPI) => {
    try {
      const response = await removeSubDomainFromActionApi(SubDomain, _id)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const getSecurityControls = createAsyncThunk<
  SecurityControls[],
  string,
  { rejectValue: string }
>('security/getSecurityControl', async (SecurityCheckId, thunkAPI) => {
  try {
    const response = await getSecurityControlsApi(SecurityCheckId)
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getSecurityControlsbylistsecurity = createAsyncThunk<
  SecurityControls[],
  string,
  { rejectValue: string }
>('security/getSecurityControl', async (SecurityCheckId, thunkAPI) => {
  try {
    const response =
      await getSecurityControlsbylistsecuritycheckApi(SecurityCheckId)
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getGlobalMaturityRate = createAsyncThunk<
  globalMaturityRateType,
  void,
  { rejectValue: string }
>('security/getGlobalMaturityRate', async (_, thunkAPI) => {
  try {
    const response = await getGlobalMaturityRateApi()
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getGlobalMaturityRateISO = createAsyncThunk<
  globalMaturityRateISOType,
  void,
  { rejectValue: string }
>('security/getGlobalMaturityRateISO', async (_, thunkAPI) => {
  try {
    const response = await getGlobalMaturityRateApiISO()
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getGlobalMaturityRateNIST = createAsyncThunk<
  globalMaturityRateNISTType,
  void,
  { rejectValue: string }
>('security/getGlobalMaturityRateNIST', async (_, thunkAPI) => {
  try {
    const response = await getGlobalMaturityRateApiNSIT()
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const calculateSecurityCheckFamilyActionsCosts = createAsyncThunk<
  calculateSecurityCheckFamilyActionsCostsType,
  string,
  { rejectValue: string }
>(
  'security/calculateSecurityCheckFamilyActionsCosts',
  async (SecurityCheckId, thunkAPI) => {
    try {
      const response =
        await calculateSecurityCheckFamilyActionsCostsApi(SecurityCheckId)
      console.log(response)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(
        'Failed to calculate Security  CheckFamilyActions Costs'
      )
    }
  }
)

export const getSecurityTreeByFamilyId = createAsyncThunk<
  SecurityTree,
  string,
  { rejectValue: string }
>('security/getSecurityTreeByFamilyId', async (SecurityCheckId, thunkAPI) => {
  try {
    const response = await getSecurityTreeByFamilyIdApi(SecurityCheckId)
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const securityControlMatrix = createAsyncThunk<
  SecurityControlMatrixType,
  void,
  { rejectValue: string }
>('security/SecurityControlMatrix', async (_, thunkAPI) => {
  try {
    const response = await securityControlMatrixApi()
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getRisksAndIncidentsBySecurityControl = createAsyncThunk<
  RisksAndIncidentsBySecurityControlType,
  string,
  { rejectValue: string }
>(
  'security/getRisksAndIncidentsBySecurityControl',
  async (SecurityControlId, thunkAPI) => {
    try {
      const response =
        await getRisksAndIncidentsBySecurityControlApi(SecurityControlId)
      console.log(response)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(
        'Failed to get Risks And Incidents BySecurityControl'
      )
    }
  }
)

export const getIntersectionByPerimetreForSecurityControl = createAsyncThunk<
  IntersectionByPerimetreForSecurityControlType,
  string,
  { rejectValue: string }
>(
  'security/getIntersectionByPerimetreForSecurityControl',
  async (SecurityControlId, thunkAPI) => {
    try {
      const response =
        await getIntersectionByPerimetreForSecurityControlApi(SecurityControlId)
      console.log(response)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(
        'Failed to get Intersection ByPerimetre For SecurityControl'
      )
    }
  }
)

export const calculateAverageActionsForSecurityControl = createAsyncThunk<
  AverageActionsType,
  string,
  { rejectValue: string }
>(
  'security/calculateAverageActionsForSecurityControl',
  async (SecurityControlId, thunkAPI) => {
    try {
      const response =
        await calculateAverageActionsForSecurityControlApi(SecurityControlId)
      console.log(response)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const calculateLateRateForSecurityControls = createAsyncThunk<
  LateRateForSecurityControlType,
  string,
  { rejectValue: string }
>(
  'security/CalculateLateRateForSecurityControl',
  async (SecurityCheckId, thunkAPI) => {
    try {
      const response =
        await CalculateLateRateForSecurityControlslApi(SecurityCheckId)
      console.log(response)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(
        'Failed to Calculate LateRate For SecurityControls.'
      )
    }
  }
)

export const getRisksAndIncidentsByExistingControl = createAsyncThunk<
  RisksAndIncidentsByExistingControlType,
  string,
  { rejectValue: string }
>(
  'security/getRisksAndIncidentsByExistingControl',
  async (ExistingControlId, thunkAPI) => {
    try {
      const response =
        await getRisksAndIncidentsByExistingControlApi(ExistingControlId)
      console.log(response)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(
        'Failed to Calculate RisksAndIncidents ByExistingControlType.'
      )
    }
  }
)

export const getExistingControlsByLabel = createAsyncThunk<
  ExistingControlsbylabelType,
  { label?: string },
  { rejectValue: string }
>('security/getExistingControlsByLabel', async (label, thunkAPI) => {
  try {
    const response = await getExistingControlsByLabelApi(label)
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(
      'Failed to get Existing Controls By LabelApi.'
    )
  }
})

export const getMaturityRateForExistingControls = createAsyncThunk<
  MaturityRateType,
  void,
  { rejectValue: string }
>('security/getMaturityRateForExistingControls', async (_, thunkAPI) => {
  try {
    const response = await getMaturityRateForExistingControlsApi()
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(
      'Failed to get Maturity Rate For ExistingControls'
    )
  }
})
export const getSecurityCheckFamiliesWithScores = createAsyncThunk<
  SecurityCheckResponse,
  string | undefined,
  { rejectValue: string }
>('security/getSecurityCheckFamiliesWithScores', async (language, thunkAPI) => {
  try {
    const response = await getwithSCFScores(language)
    console.log('response', response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(
      'Failed to get Security Check Families with Scores'
    )
  }
})
export const getSecurityCheckFamiliesWithScoresById = createAsyncThunk<
  SecurityCheckFamilyResponseSCFS,
  { id: string; language?: string },
  { rejectValue: string }
>('security/getSecurityCheckFamiliesWithScoresById', async ({ id, language }, thunkAPI) => {
  try {
    const response = await getwithSCFScoresByid(id, language)
    console.log('response', response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(
      'Failed to get Security Check Families with Scores'
    )
  }
})
export const fetchSecurityCheckFamilyByCategory = ({
  category,
  page,
  pageSize,
  language,
}: {
  category: string
  page: number
  pageSize: number
  language?: string
}) => {
  switch (category) {
    case 'ISO':
      return getSecurityISO({ page, pageSize, language })
    case 'ISO_13':
      return getSecurityISO({ page, pageSize, language, source: 'ISO2013' })
    case 'ISO_22':
      return getSecurityISO({ page, pageSize, language, source: 'ISO2022' })
    case 'NIST':
      return getSecurityNIST({ page, pageSize, language })
    case 'SWIFT':
      return fetchSecurityCheckFamilyBySWIFTSource({ page, pageSize, language })
    case 'SAMA':
      return fetchSecurityCheckFamilyBySAMASource({ page, pageSize, language })
    case 'NIS2':
      return fetchSecurityCheckFamilyByNIS2Source({ page, pageSize, language })
    case 'SOC':
      return fetchSecurityCheckFamilyBySOCSource({ page, pageSize, language })
    default:
  }
}
export const fetchSecurityCheckFamilyBySAMASource = createAsyncThunk<
  GetSecurityCheckFamilyBySourceResponse,
  { page?: number; pageSize?: number; language?: string },
  { rejectValue: string }
>(
  'securityCheckFamily/fetchBySAMASource',
  async (
    { page = 1, pageSize = 10, language = i18n.language.toLocaleUpperCase() },
    thunkAPI
  ) => {
    try {
      return await getSecurityCheckFamilyBySAMASource(page, pageSize, language)
    } catch (error) {
      return thunkAPI.rejectWithValue(
        'Failed to fetch Security Check Families by SAMA Source.'
      )
    }
  }
)

export const fetchSecurityCheckFamilyByNIS2Source = createAsyncThunk<
  GetSecurityCheckFamilyBySourceResponse,
  { page?: number; pageSize?: number; language?: string },
  { rejectValue: string }
>(
  'securityCheckFamily/fetchByNIS2Source',
  async ({ page = 1, pageSize = 10, language = i18n.language }, thunkAPI) => {
    try {
      return await getSecurityCheckFamilyByNIS2Source(page, pageSize, language)
    } catch (error) {
      return thunkAPI.rejectWithValue(
        'Failed to fetch Security Check Families by NIS2 Source.'
      )
    }
  }
)
